import { BuildingOfficeIcon } from "@heroicons/react/24/solid";
import { Navigate, useParams } from "@tanstack/react-router";
import * as React from "react";
import { socialProfile } from "app/router";
import { SocialPostWrapper } from "screens/social/post/SocialPostWrapper";
import { Avatar, Button, Heading, Rows, Separator, Spinner } from "components/elements";
import { useFollow } from "hooks/useFollow";
import { usePublicUser } from "hooks/usePublicUser";
import { ClientPost } from "@compass/shared/types";

export const Profile = () => {
    const id = parseInt(useParams({ from: socialProfile.id }).id);
    const { user, isInitialLoading } = usePublicUser(id);

    const { handleFollow, followLoading, showFollowButton, isFollowed } = useFollow(id);

    function scrollTop() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    React.useEffect(() => {
        scrollTop();
    }, []);

    if (isInitialLoading) {
        return (
            <span className="absolute inset-0 flex items-center justify-center">
                <Spinner className="h-10 w-10 text-slate-500" />
            </span>
        );
    }
    if (!user) {
        return <Navigate to="/" />;
    }

    return (
        <div>
            <Rows className="relative flex h-[13rem]">
                <Avatar
                    className="absolute bottom-[-2.5rem] h-[10rem] w-[10rem] shrink-0 border-4 border-slate-300 bg-slate-200 text-3xl text-slate-400 shadow-inner"
                    photoUrl={user?.avatarUrl}
                    name={user.name}
                />
                {showFollowButton && (
                    <Button
                        className="w-50 absolute right-8"
                        onClick={handleFollow}
                        isLoading={followLoading}
                        variant={isFollowed ? "secondary" : "primary"}
                    >
                        {isFollowed ? "Unfollow" : "Follow"}
                    </Button>
                )}
            </Rows>

            <Rows className="mt-8">
                <div className="flex flex-col bg-white p-4">
                    <Rows>
                        <div className="text-xl text-slate-800">{user.name}</div>
                        <div className="flex items-center gap-2">
                            <BuildingOfficeIcon className="h-5 w-5 text-slate-500" />
                            <div className="text-medium text-slate-700">
                                {user?.meta.organization}
                            </div>
                        </div>

                        <div className="text-sm">{user?.meta.bio}</div>
                    </Rows>
                </div>

                <div className="h-4" />
                <Separator />
                <div className="h-4" />

                <div className="flex flex-col gap-3">
                    <Heading>Posts</Heading>

                    <div className="flex flex-col gap-5">
                        {(user?.posts as ClientPost[] | null)?.length
                            ? (user?.posts as ClientPost[])
                                  ?.filter((post) => !post.isAnonymous)
                                  .map((post, key) => (
                                      <div key={key}>
                                          <SocialPostWrapper isProfile post={post} />
                                      </div>
                                  ))
                            : null}
                    </div>
                </div>
            </Rows>
        </div>
    );
};
